import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, map, switchMap } from 'rxjs/operators';
import { extractDocumentCharacters } from 'src/app/helpers/utils/cpf-cnpj.util';
import { CreditRegisterService } from 'src/app/pages/register/credit-register/service/credit-register.service';

const recentComitenteChecks = new Map<string, { checkedAt: number; result: ValidationErrors | null }>();
const RECENT_CHECK_TTL_MS = 3000;

/** Limpa cache de validações recentes — uso exclusivo em testes. */
export function clearComitenteValidatorCache(): void {
  recentComitenteChecks.clear();
}

export function comitenteBackendValidator(
    service: CreditRegisterService,
    getAccountCode: () => string
): AsyncValidatorFn {

    return (control: AbstractControl): Observable<ValidationErrors | null> => {

        const documentNumber = extractDocumentCharacters(control.value);

        const accountCode = getAccountCode();

        if (
            (documentNumber.length !== 11 && documentNumber.length !== 14) ||
            !accountCode
        ) {
            return of(null);
        }

        const cacheKey = `${documentNumber}:${accountCode}`;
        const cached = recentComitenteChecks.get(cacheKey);
        if (cached && Date.now() - cached.checkedAt < RECENT_CHECK_TTL_MS) {
            return of(cached.result);
        }

        return of(documentNumber).pipe(
            debounceTime(300),
            switchMap(doc =>
                service.checkInvestor(doc, accountCode).pipe(
                    map((response: any) => {
                        const isValid = response?.data?.accountIndicator === true;
                        const result = isValid ? null : { comitenteInvalido: true };
                        recentComitenteChecks.set(cacheKey, {
                            checkedAt: Date.now(),
                            result,
                        });
                        return result;
                    }),
                    catchError(() => {
                        const result = { backendError: true };
                        recentComitenteChecks.set(cacheKey, {
                            checkedAt: Date.now(),
                            result,
                        });
                        return of(result);
                    })
                )
            )
        );
    };
}
